export default {
  actions: {
    actionSetPopupStatus: (context, bool = false) => context.commit('mutationSetPopupStatus', bool),
    actionImagePopupUpload: (context, bool = false) =>  context.commit('mutationImagePopupUpload', bool),
  },
  mutations: {
    mutationSetPopupStatus: (state, bool) => state.popup_status = bool,
    mutationImagePopupUpload: (state, bool) => state.upload_images = bool,
  },
  state: {
    popup_status: false,
    upload_images: false
  },
  getters: {
    getPopupStatus: state => state.popup_status,
    getImagePopupUpload: state => state.upload_images,
  }
}
